import { Capacitor } from "@capacitor/core";
import { shareLogFile, shareOpenDocument, writeShareableTextFile } from "./logger";

/** Copy text to clipboard (native + web). */
export async function copyText(text: string): Promise<void> {
  const t = text.trim();
  if (!t) throw new Error("متنی برای کپی نیست.");
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(t);
    return;
  }
  const ta = document.createElement("textarea");
  ta.value = t;
  ta.style.position = "fixed";
  ta.style.left = "-9999px";
  document.body.appendChild(ta);
  ta.select();
  document.execCommand("copy");
  document.body.removeChild(ta);
}

/** Share plain text via ShareFile / Web Share. */
export async function shareText(
  text: string,
  fileName = "nevisign-text.txt"
): Promise<void> {
  const exported = await writeShareableTextFile(fileName, text);
  await shareLogFile(exported, { title: fileName });
}

/** Save binary bytes and open system share (PDF tools). */
export async function saveAndShareBytes(
  bytes: Uint8Array,
  fileName: string,
  mimeType: string
): Promise<void> {
  const safe = fileName.replace(/[^\w.\u0600-\u06FF-]+/g, "_") || "file.bin";
  const ab = bytes.buffer.slice(
    bytes.byteOffset,
    bytes.byteOffset + bytes.byteLength
  ) as ArrayBuffer;
  await shareOpenDocument({
    fileName: safe,
    buffer: ab,
    mimeType,
  });
  void Capacitor;
}
